/** SUPPORT-ONLY. Shared types for the OCPP timelog tool. */

/** Which input the support user is searching by. */
export type LookupMode = 'charger' | 'receipt' | 'transaction' | 'session';

/** The API rejects `limit` above 1000, so always request the max. */
export const MESSAGE_LIMIT = 1000;
export const DEFAULT_PADDING_MINUTES = 5;

export const parsePaddingMinutes = (value: string | number | undefined): number => {
  const n = typeof value === 'number' ? value : Math.floor(Number(value));
  return Number.isFinite(n) && n >= 0 ? n : DEFAULT_PADDING_MINUTES;
};

/**
 * The fully-resolved view state. The URL only stores the minimal set needed to
 * reconstruct it (see urlState.ts) — mode and ocppTxId are derived on load.
 *  - chargerId + from/to drive the OCPP log fetch (and the date-range picker).
 *  - fromSpec/toSpec are the picker's TimeSpec-encoded strings for the URL, so
 *    relative/now modes survive link sharing (e.g. "~1d-ago", "now").
 *  - receiptId drives the billing overlay (re-fetched to rebuild it).
 *  - focus* + connector/ocppTxId reproduce the highlight + scope.
 */
export interface TimelogState {
  mode: LookupMode;
  chargerId: string;
  from: string; // ISO — resolved dates used for the API call
  to: string; // ISO
  fromSpec?: string; // TimeSpec-encoded (e.g. "~1d-ago", "now") for URL
  toSpec?: string;
  receiptId?: string;
  focusFrom?: string; // ISO
  focusTo?: string; // ISO
  connector?: number;
  ocppTxId?: number;
  txnId?: string;
  sessionId?: string;
}
